import { BrowserType, BrowserTypeValue } from '../constants/browser-type';

export function getBrowserType(): BrowserTypeValue {
  if (navigator.userAgent.indexOf('Opera') !== -1 || navigator.userAgent.indexOf('OPR') !== -1) {
    return BrowserType.OPERA;
  } else if (navigator.userAgent.indexOf('Edg') !== -1) {
    return BrowserType.EDGE;
  } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
    return BrowserType.CHROME;
  } else if (navigator.userAgent.indexOf('Safari') !== -1) {
    return BrowserType.SAFARI;
  } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
    return BrowserType.FIREFOX;
  } else if (navigator.userAgent.indexOf('MSIE') !== -1 || !!document['documentMode'] === true) {
    return BrowserType.EXPLORER;
  }
  return BrowserType.OTHER;
}
